<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1300px"
      show-save-button
      unit="盘点单"
      edit-title
      id-key="commentId"
      :data="data"
      :form-rules="rules"
      :get-data-func="api.info"
      :save-func="api.save"
      :before-save="onBeforeSave"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      close-on-saved
      @close-saved="$emit('close-saved')"
      @close="onClose" 
    >
      <template slot="form">
        <el-row>
          <el-col :span="6">
            <el-form-item label="单据编号" prop="DocNo">
              <el-input
                v-model="data.DocNo"
                placeholder="请输入单据编号"
                v-if="noEdit"
              ></el-input>
              <span v-else>{{ data.DocNo }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="单据日期" prop="DocDate">
              <el-date-picker
                size="mini"
                v-model="data.DocDate"
                placeholder="请选择日期"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="盘点仓库" prop="WarehouseId">
              <el-select
                size="mini"
                v-model="data.WarehouseId"
                placeholder="请选择"
                :disabled="isSelDisabled"
              >
              <el-option v-for="item in wareList" :key="item.WarehouseId" :label="item.WarehouseName" :value="item.WarehouseId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="盘点人员" prop="EmpName">
              <el-input v-model="data.EmpName" @focus="addEmp" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="账面日期" prop="BookDate">
              <el-date-picker
                size="mini"
                v-model="data.BookDate"
                placeholder="请选择日期"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="盘点方式" prop="InventoryWay">
               <el-radio-group v-model="data.InventoryWay" @change="changeWay">
                <el-radio :label="0">实物盘点</el-radio>
                <el-radio :label="1">商品清单盘点</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注" prop="Remark">
              <el-input v-model="data.Remark" placeholder="请填写备注" size="mini"></el-input>
            </el-form-item>
          </el-col>
          <dialog-list ref="dialogList" :info="data" v-if="data.InventoryWay===0" @onSelect="onSelect" />
          <dialog-goodslist ref="goodsList" :info="data" v-if="data.InventoryWay===1" />
        </el-row>
      </template>
         <template slot="footer">
        <!-- <el-button size="mini" type="danger" @click="cancelExamine" v-if="data.Status==2&&canExa">弃 审</el-button>
        <el-button size="mini" type="success" @click="examine" v-else-if="canExa">审 核</el-button> -->
      </template>
    </common-dialog>
    <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import empDialog from "@/components/sales/business/empDialog";
import dialogList from "./dialogList";
import dialogGoodslist from "./dialogGoodslist";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    empDialog,
    dialogList,
    dialogGoodslist
  },
  data() {
    return {
      data: {
        DocId: 0,
        InventoryDocId: 0,
        DocType: 0,
        DocNo: "",
        DocDate: "",
        WarehouseId: null,
        EmpId: 0,
        BookDate: "",
        InventoryWay: 0,
        Remark: "",
        Status: 0,
        EmpName: "",
        Goods:[],
      },
      noEdit: false,
      canExa: false,
      wareList: [],
      initTableData:[
        {
          T: 0,
          OrderGoodsId: 0,
          DocId: 0,
          BarCode: "",
          GoodsName: "",
          GoodsId:"",
          Model:"",
          UnitId: 0,
          UnitName:"",
          Quantity: 0,
          BatchNo:"",
          Offer:  0,
          Discount: 100,
          Price: 0,
          ExistQuantity:  0,
          AvailableQuantity:  0,
          TaxRate: 0,
          TaxAmount: 0,
          Amount: 0,
          NoTaxAmount: 0,
          PromotionType: 0,
          PromotionId: 0,
          ReferenceCost:  0,
          GrossProfit: 0,
          Remark: "",
          Thumbnail: "",
          OutQuantity: 0,
          AddTime: "",
          InventoryQuantity:  0,
          DiffQuantity:0,
        }
      ],
      api: require("@/api/stock/inventory").default,
      billApi: require("@/api/sy/bill").default,
      rules: {
        WarehouseId: [{ required: true, message: "盘点仓库不能为空" }],
        EmpName: [{ required: true, message: "盘点人员不能为空" }],
        InventoryWay: [{ required: true, message: "请选择盘点方式" }],
      },
      isSelDisabled: false
    };
  },
  beforeMount() {
    let date = new Date()
    date.setTime(date.getTime());
    let today = date.getFullYear()+"-" + (date.getMonth()+1) + "-" + date.getDate();
    if(!this.data.DocDate) {
      this.data.DocDate = today
      this.data.BookDate = today
    }
  },
  methods: {
    onClose(){
      this.isSelDisabled = false
    },
    onSelect(){
      this.isSelDisabled = true
    },
    examine() {
      this.$confirm("确认审核数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
      .then(() => {
        this.api.examine(this.data.DocId).then(res => {
          if(res.Code ==0) {
            this.$message.success("审核成功")
            this.close()
            this.$emit("close-saved")
          } else {
            this.$message.error(res.Msg)
          }
        })
      })
    },
    cancelExamine() {
      this.$confirm("确认弃审数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
      .then(() => {
        this.api.cancelExamine(this.data.DocId).then(res => {
          if(res.Code ==0) {
            this.$message.success("弃审成功")
            this.close()
            this.$emit("close-saved")
          } else {
            this.$message.error(res.Msg)
          }
        })
      })
    },
    addEmp() {
      this.$refs.empDialog.open().then((that) => {
        that.getData({ Status: 1 });
      });
    },
    setEmp(e) {
      this.data.EmpId = e.EmpId
      this.data.EmpName = e.EmpName
    },
    changeWay(e) {
      
    },
    onCreateOpened() {
      this.isSelDisabled = false
      this.canExa = false
      this.wareList = JSON.parse(sessionStorage.getItem("ware"))
      this.$refs.dialogList.tableData = JSON.parse(JSON.stringify(this.initTableData))
      this.$refs.dialogList.tableDel = []
      this.billApi.getDefaultSerialNo("盘点单").then(res => {
        if(res.Code==0&&res.Data) {
          this.data.DocNo = res.Data
        } else if(res.Code==0) {
          this.noEdit = true
        } else {
          this.$message.warning(res.Msg)
        }
      })
    },
    onEditOpened() {
      this.isSelDisabled = true
      this.wareList = JSON.parse(sessionStorage.getItem("ware"))
      this.canExa = true
      this.$refs.dialogList.tableData = []
      this.$refs.dialogList.getData()
    },
    onBeforeSave() {
      let tableData = this.$refs.dialogList.tableData;
      let tableDel = this.$refs.dialogList.tableDel;
      
      let tb = []
      if(tableData.length==0 || !tableData.some(v=>v.GoodsId)) {
        this.$message.error("请填写商品列表");
        return false;
      }

      const goodsIds = tableData.map(v=>v.GoodsId).filter(Boolean);
      if((new Set(goodsIds)).size != goodsIds.length){
        this.$message.error("商品不能重复");
        return false;
      }
      for(var i = 0; i < tableData.length; i++) {
        if(tableData[i].GoodsId){
        if(!tableData[i].Quantity) {
          this.$message.error("请填写盘点数量");
          return false;
        }
        




        // if (!tableData[i].InventoryQuantity) {
        //   this.$message.error("请填写账面数量");
        //   return false;
        // }
        // if (!tableData[i].DiffQuantity) {
        //   this.$message.error("请填写盈亏数量");
        //   return false;
        // }
        if(tableData[i].T===0||tableData[i].T===1) {
          tb.push(tableData[i])
        }
        }
      }
      this.data.Goods = tb.concat(tableDel)
      return true
    },
  },
};
</script>